import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "72",
  height: "77",
  fill: "none",
  viewBox: "0 0 72 77"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"#000\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" d=\"M57 31.292V5H19m38 53.292v13.291H11V14.292m0 0h8V5m-8 9.292L19 5M18.3 22.897h31.9M18.3 30.276h31.9M18.3 37.335h31.9M18.3 63.157h18.3\"></path><g stroke=\"#000\" stroke-miterlimit=\"10\" clip-path=\"url(#purchase-on-invoice_svg__a)\"><path d=\"m50.524 60.076-4.494 3.332.477-5.574 13.599-24.362 4.016 2.242zM62.416 38.77 58.4 36.528M50.524 60.076l-4.017-2.242\"></path></g><defs><clipPath id=\"purchase-on-invoice_svg__a\"><path fill=\"#fff\" d=\"m59.913 32.792 4.89 2.729-16.913 30.3L43 63.09z\"></path></clipPath></defs>", 3)
  ])))
}
export default { render: render }